import mqtt from 'mqtt'
import { MQTT_HOST, MQTT_PORT, MQTT_PROTOCOL, MQTT_USER, MQTT_PASSWORD } from '../constants/appConstants'

const host = `${MQTT_PROTOCOL}://${MQTT_HOST}:${MQTT_PORT}`
const mqttOptions = {
  protocol: MQTT_PROTOCOL,
  username: MQTT_USER,
  password: MQTT_PASSWORD,
  clean: true,
}

export const mqttConnect = () => {
  return mqtt.connect(host, {
    ...mqttOptions,
    clientId: 'web_' + parseInt(Math.random() * 10000, 10),
  })
}

export const mqttSubscribe = (client, topic) => {
  // Allow only one subscription per topic
  const alreadySubscribed = Object.values(client.messageIdToTopic).some(topics => topics.includes(topic))
  if (alreadySubscribed) {
    return
  }

  client.subscribe(topic, error => {
    if (error) {
      console.log('Subscribe to topics error', error)
      return
    }

    console.log('Subscribed to topic', topic)
  })
}

export const mqttDisconnect = client => {
  client.end(true, () => {
    console.log('Disconnected')
  })
}

export const mqttUnSubscribe = (client, topic) => {
  client.unsubscribe(topic, error => {
    if (error) {
      console.log('Unsubscribe error', error)
      return
    }

    console.log('Unsubscribed from topic', topic)
    const topicEntry = Object.entries(client.messageIdToTopic).find(([, topics]) => topics.includes(topic))
    if (topicEntry) {
      delete client.messageIdToTopic[topicEntry[0]]
    }
  })
}
